// Organization membership role options
// These are suggested roles that users can select from or they can type their own custom role

export const ORGANIZATION_ROLES = [
  // Academic Faculty
  'Faculty',
  'Professor',
  'Associate Professor',
  'Assistant Professor',
  'Lecturer',
  'Adjunct Professor',
  'Visiting Professor',
  'Emeritus Professor',
  
  // Research Positions
  'Researcher',
  'Research Associate',
  'Research Assistant',
  'Postdoctoral Researcher',
  'Principal Investigator',
  'Co-Investigator',
  'Research Fellow',
  'Visiting Scholar',
  
  // Students
  'PhD Student',
  'Doctoral Student',
  'Master\'s Student',
  'Undergraduate Student',
  'Graduate Student',
  'Student',
  
  // Laboratory Roles
  'Lab Manager',
  'Lab Technician',
  'Lab Coordinator',
  'Lab Assistant',
  
  // Management & Leadership
  'Director',
  'Associate Director',
  'Assistant Director',
  'Department Head',
  'Department Chair',
  'Dean',
  'Associate Dean',
  'Project Manager',
  'Program Manager',
  'Program Director',
  
  // Administrative & Support
  'Administrative Staff',
  'Staff',
  'Coordinator',
  'Administrator',
  'Secretary',
  
  // Other Professional Roles
  'Intern',
  'Consultant',
  'Collaborator',
  'Advisor',
  'Clinical Researcher',
  'Data Scientist',
  'Research Scientist',
  'Senior Scientist',
  'Bioinformatician',
  'Statistician',
  
  // Catch-all
  'Other'
];

export default ORGANIZATION_ROLES;
